import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Provider } from "@devowl-wp/real-product-manager-wp-client";
import { ConfigLicensingConsumer } from "./consumer.js";
const ConfigLicensing = observer(()=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            maxWidth: 800,
            margin: "auto",
            padding: "20px 0"
        },
        children: /*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(ConfigLicensingConsumer, {})
        })
    });
});
export { ConfigLicensing };
